import React, {useEffect, useRef} from "react";
import "./OnlineSlider.scss";
import Swiper from "swiper";
import {useHistory} from "react-router-dom";



function OnlineSlider(props) {

    const history = useHistory()
    const swiper = useRef(null)
    const Loop = ()=>{
        setInterval(()=>{
            try{
                swiper.current.slideNext();
            }catch (e) {
                // console.log(e)
            }
        },4000)
    }

    useEffect(()=>{


        if(props.data){
            swiper.current=new Swiper('.swiper-on-container',{
                loop:true,
            })
            try{
                swiper.current.on("click", function(e) {
                    /* do something */
                    // console.log(this.clickedSlide.attributes[1].value);
                    // console.log(props.data[parseInt(this.clickedSlide.attributes[1].value)])
                    let item = props.data[parseInt(this.clickedSlide.attributes[1].value)];
                    // props.dispatch(item.link_to,item)
                });
            }catch (e) {
                // console.log(e)
            }

        }
        // Loop();
    },[])

    const goTo = (sli)=>{
        switch (sli.link_to) {
            case 'merchant_category_with_subcategory':
                history.push(`/online-store-categories/${props.merchant}/${sli.link_to_uid}`)
                break;
            case 'merchant_category_without_subcategory':
                history.push(`/online-store-categories/${props.merchant}/${sli.link_to_uid}`)
                break;
        }
    }

    return(
        <div className="online-slider_container">
            {props.data?<div className="swiper-on-container swiper1">
                <div className="swiper-wrapper">
                    {props.data.map(item=>{
                        return(
                            <div key={item.uid} className="swiper-slide"  onClick={()=>{
                                // goTo(item)
                            }}>
                                <img alt={"slider"+item.uid}  src={item.image} />
                                {/*<LazyImage type={"slide"} src={item.image}/>*/}
                            </div>
                        )
                    })}
                </div>
            </div>:null}
        </div>
    )
}

export {OnlineSlider};
